class r {
  constructor(e = !1) {
    this.storage = e ? localStorage : sessionStorage;
  }
  get(e) {
    const t = this.storage.getItem(e);
    if (t)
      return JSON.parse(t);
  }
  set(e, t) {
    this.storage.setItem(e, JSON.stringify(t));
  }
  remove(e) {
    this.storage.removeItem(e);
  }
}
export {
  r as default
};
